import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const translationRegex = /^[\p{L}\p{N}\s''&\-()/.,!]+$/u;

export const useUpdateDestinationTranslationsDialogValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z
    .object({
      pl: z
        .string()
        .refine(val => !val || val.length >= 1, {
          message: t('required'),
        })
        .refine(val => !val || val.length <= 255, {
          message: t('maxCharacters', { count: 255 }),
        })
        .refine(val => !val || translationRegex.test(val), {
          message: t('invalidFormat'),
        })
        .optional(),

      en: z
        .string()
        .refine(val => !val || val.length >= 1, {
          message: t('required'),
        })
        .refine(val => !val || val.length <= 255, {
          message: t('maxCharacters', { count: 255 }),
        })
        .refine(val => !val || translationRegex.test(val), {
          message: t('invalidFormat'),
        })
        .optional(),

      ua: z
        .string()
        .refine(val => !val || val.length >= 1, {
          message: t('required'),
        })
        .refine(val => !val || val.length <= 255, {
          message: t('maxCharacters', { count: 255 }),
        })
        .refine(val => !val || translationRegex.test(val), {
          message: t('invalidFormat'),
        })
        .optional(),
    })
    .strict();
};
